import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "write" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Write", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "-- SRC LANG --", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "row mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "muted small" }, [
  /*#__PURE__*/_createTextVNode("Type your word(s) below, if in most cases the first word matches just type and hit "),
  /*#__PURE__*/_createElementVNode("strong", null, "TAB"),
  /*#__PURE__*/_createTextVNode(", make sure you hit "),
  /*#__PURE__*/_createElementVNode("strong", null, "tab"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "space"),
  /*#__PURE__*/_createTextVNode(" after selecting the word to commit it.")
], -1)
const _hoisted_7 = ["data-language"]
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "muted small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("select", {
      class: "form-control",
      id: "language",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
      required: "true",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLanguage($event)))
    }, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.languages), (l) => {
        return (_openBlock(), _createElementBlock("option", {
          key: l,
          value: l
        }, _toDisplayString(l), 9, _hoisted_4))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.selectedLanguage]
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("textarea", {
        class: "autocomplete col-12",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taValue) = $event)),
        "data-language": _ctx.selectedLanguage
      }, null, 8, _hoisted_7), [
        [_vModelText, _ctx.taValue]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_editor, {
          class: "autocomplete",
          modelValue: _ctx.taValue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.taValue) = $event)),
          "api-key": "8kpycxhjheir0b2odz6yw1kfsyxo9pm6qtaa0u5temvzej6u",
          id: "src",
          init: {
                    plugins: 'paste code',
                    paste_as_text: true
                },
          placeholder: "Type text to convert"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("p", _hoisted_10, "selectedLanguage=" + _toDisplayString(_ctx.selectedLanguage), 1)
  ]))
}